// eslint-disable-next-line import/no-import-module-exports
import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import reducerPath from '../../app/reducerPath';
// eslint-disable-next-line import/no-unresolved,boundaries/element-types
import { AUTH_FIELDS, clearStorage } from '../auth/tokenResource/redux/tokenResource';
import handleError from '../../shared/api/handleError';
import HttpMethods from '../../shared/api/HttpMethods';

const COMMON_FIELDS = {
  ERROR: 'error',
  STATUS: 'status',
  DATA: 'data',
  TYPE: 'type',
};

const HTTP_STATUSES = {
  UNAUTHORIZED: 401,
};

const AUTH_ENDPOINTS = ['/authenticate', '/authorizeByVK', '/oauth'];

export const isAuthRequest = (url) => AUTH_ENDPOINTS.some((endpoint) => url?.includes(endpoint));

const getTokenFromApi = (api) => {
  const state = api.getState();
  if (state && typeof state === 'object') {
    if (state?.[`${reducerPath.tokenResource}/counter`]?.[AUTH_FIELDS.TOKEN_ACCESS]) {
      return state[`${reducerPath.tokenResource}/counter`][AUTH_FIELDS.TOKEN_ACCESS];
    }
  }
  // eslint-disable-next-line no-undef,implicit-arrow-linebreak
  return window.localStorage.getItem('token') || window.sessionStorage.getItem('token');
};
const baseQueryFn = async (args, api, extraOptions, baseUrl) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: `${baseUrl}`,
    prepareHeaders: (headers) => {
      const token = getTokenFromApi(api);
      if (token) headers.set('Authorization', `Bearer ${token}`);
      headers.set('Access-Control-Allow-Origin', '*');
      headers.set('Accept', 'application/json');
      headers.set('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept');
      headers.set('Access-Control-Allow-Methods', 'DELETE, PUT, UPDATE, HEAD, OPTIONS, GET, POST');
    },
  });

  return baseQuery(args, api, extraOptions);
};

export const vkRedirectGetMyTokenPage = (prevUrl, isRegistration) => {
  // @vkid/sdk автоматически обрабатывает авторизацию через Config.init()
  // Для регистрации просто редиректим на страницу логина, где будет OneTap
  // prevUrl и isRegistration сохраняются для последующей обработки
  const returnUrl = isRegistration ? '/login?registration=true' : '/login';
  // eslint-disable-next-line no-restricted-globals
  location.assign(returnUrl);
};

export const redirectToLoginPage = (prevUrl) => {
  // редирект на страницу логина с передачей текущего URL в state
  const loginUrl = `/login?state=${prevUrl}`;

  // редирект через assign, чтобы можно было вернуться
  // eslint-disable-next-line no-restricted-globals
  location.assign(loginUrl);
};

// Функция для выполнения запроса на обновление токена
export const refreshTokenModule = async () => {
  const isVkAuth = sessionStorage.getItem('isAuthVk') || localStorage.getItem('isAuthVk');

  clearStorage();

  const currentPath = window.location.pathname + window.location.search;
  if (isVkAuth) {
    // TODO: новый VK OAuth флоу
  } else {
    redirectToLoginPage(currentPath);
  }
  return null;
};

const baseQueryWithReAuth = async (args, api, extraOptions, baseUrl) => {
  const isToastUI = (args?.body || args?.params)?.isToastUI;
  const body = args?.body;
  delete body?.isToastUI;
  const params = { ...args?.params };
  delete params?.isToastUI;
  let newArgs = args;
  if (args?.method === HttpMethods.GET) {
    newArgs = {
      ...newArgs,
      params,
    };
  } else {
    newArgs = {
      ...newArgs,
      body,
    };
  }
  const result = await baseQueryFn(newArgs, api, extraOptions, baseUrl);
  const status = result?.meta?.response?.status;
  const url = result?.meta?.request?.url;

  if (status === HTTP_STATUSES.UNAUTHORIZED && !isAuthRequest(url)) {
    await refreshTokenModule();
  }

  if (!result?.meta?.response?.ok) {
    return {
      [COMMON_FIELDS.ERROR]: {
        [COMMON_FIELDS.DATA]: handleError(result, { isRTK: true, isToastUI }),
      },
    };
  }

  return result;
};

export default baseQueryWithReAuth;
